'use strict';

import controller from './asyncDataTracking.controller.js';

const component = {
    bindings: {},
    controller
};

export default component;
